import React from "react";
import "./header.css";

const Header = () => {
  return (
    <div className="home-header">
      <h3>
        CATCH ALL THE BEST AND LATEST MOVIES RIGHT HERE ON THE{" "}
        <span className="m-box">MOVIE BOX</span>
      </h3>
    </div>
  );
};

export default Header;
